export const appType = 'main'; // 'club';
export const clubId = null; //310510386;
export const organizerId = null;
export const appClient = null;
export const membersOnly = false;
export const DEFAULT_REDIRECT = 'tabs/player-home';

// export const appType = 'club'; // 'club';
// export const clubId = 310510386; //310510386;

export const MygolfServerHost = 'betalet.mygolf2u.com';
// export const MygolfServerHost = 'clslet.mygolf2u.com';
export const MygolfUIServerHost = 'beta-play.mygolf2u.com';
export const MygolfSSLEnable = true;

export const devMode = false;
export const toggleDevMode = false;
export const environment = 'dev';
export const enableChat = false;
export const chatServer = 'betachat.mygolf2u.com';
export const chatPort = '11014';

export const filterNewsPromoByDates = false;

export const enableStayNPlayRequest = true;

export const majorAppVersion = '5.0.0';

// Live Update Configuration
export const updateConfig = {
  enabled: false, // DISABLED: CapacitorUpdater has fundamental Android compatibility issues
  autoCheck: true,
  checkInterval: 3600000, // 1 hour in milliseconds
  autoDownload: true,
  mandatoryUpdateDelay: 300000, // 5 minutes in milliseconds
  useStaticServer: false, // Use static server without token auth (for testing)
  updateServerUrl: 'https://betaupdates.mygolf2u.com',
  tokenEndpoint: 'https://betaupdates.mygolf2u.com/api/updates/token',
  publicKey: '',
};

export const MygolfPortal = 'beta.mygolf2u.com';
